import styled, { css } from "styled-components/native";
import styledRN from "rn-css";
import { black, spacing_l, spacing_m, white } from "../../StyleHelpers";
import { StyleSheet } from "react-native";
import { Props } from "./model";

//#region TDP index styles
export const StyledContainerTdp = styled.View`
	height: 100vh;
	background-color: ${black};
`;

export const StyledTabsContainer = styled.View<any>`
	width: ${(props) => (props.isNarrow ? "auto" : "100%")};
	height: 100vh;
	background-color: ${black};
`;

export const StyledMain = styled.View<Props>`
	${(props) =>
		!props.isNarrow &&
		css`
			height: 100%;
			width: 100%;
			z-index: -1;
			position: relative;
		`}

	${(props) =>
		!props.bgImage &&
		css`
			background-color: black;
		`}

	${(props) =>
		props.bgImage &&
		!props.isNarrow &&
		css`
			background-image: url(${props.bgImage});
			background-position: 80%;
			background-repeat: no-repeat;
			background-size: cover;
		`}
`;

export const StyledMainNarrow = styled.View<any>`
	position: fixed;
	right: 0;
	bottom: 0;
	width: 50vw;
	height: calc(100vh - 5rem);
`;

export const StyledMarquee = styled.View<any>`
	cursor: ${(props) => (props.hover ? "pointer" : "normal")};
`;

export const TabsContainer = styled.View<any>`
	margin: ${(props) => (props.isNarrow ? "5rem 0 0 0" : "7rem 0 0 0")};
	position: absolute;
	width: 100%;
	z-index: -1;
	background-color: black;
`;

export const StyledContainerColumn = styled.View<any>`
	flex-direction: row;
	height: 100%;
	${(props) =>
		props.isNarrow &&
		css`
			display: flex;
			width: 81.25rem;
			flex-direction: row;
			padding: 2rem 1.5rem;
			justify-content: space-between;
			align-items: flex-start;
		`}
`;

export const StyledImage = styled.View`
	margin-top: ${spacing_l};
	display: flex;
`;

export const StyledPackshot = styledRN.View`
	width: 420px;
	height: 630px;
	border-radius: 16px;
	overflow: hidden;
	position: absolute;

	@media (max-width: 640px) {
		margin-top:50px;
		width: 160px;
		height: 270px;
	}
	@media (min-width: 640px) {
		width: 300px;
		height: 480px;
	}
	@media (min-width: 768px) {
		margin-left:60px;
		width: 320px;
		height: 500px;
	}
	@media (min-width: 1536px) {
		margin-left:112px;
		width: 420px;
		height: 630px;
	}
`;

export const StyledLoading = styledRN.View`
	width: 420px;
	height: 630px;
	border-radius: 16px;
	overflow: hidden;
	position: absolute;
	z-index: -1;
	@media (max-width: 640px) {
		margin-top:50px;
		width: 160px;
		height: 270px;
	}
	@media (min-width: 640px) {
		width: 300px;
		height: 480px;
	}
	@media (min-width: 768px) {
		margin-left:60px;
		width: 300px;
		height: 480px;
	}
	@media (min-width: 1536px) {
		margin-left:112px;
		width: 420px;
		height: 630px;
	}
`;

//#endregion

//#region Details Style
export const StyledContainer = styled.View<{ isPreview: boolean }>`
	padding: ${(props) => (props.isPreview ? "0px 122px 70px 122px" : "0px 122px 0px 122px")};
	height: 100%;
	z-index: -1;
`;

export const StyledOverflow = styled.View`
	padding-right: 20px;
`;

export const StyledText = styled.View<any>`
	flex-direction: row;
	align-items: center;
	margin-bottom: ${(props) => (props.isNarrow ? "" : spacing_l)};
`;

export const StyledCast = styled.Text`
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
`;

export const StyledColumn1 = styled.View<any>`
	width: ${(props) => (props.isNarrow ? "10.75rem" : "15%")};
`;

export const StyledColumn2 = styled.View`
	width: 81%;
`;

export const StyledColumnText = styled.Text`
	text-align: left;
	color: ${white};
`;

export const styles = StyleSheet.create({
	metadata: {
		color: "white",
	},
	button: {
		fontSize: 25,
		color: "white",
	},
});
//#endregion

// #region Extras Style
export const StyledContainerExtras = styled.View<any>`
	padding: ${(props) => (props.isNarrow ? `${spacing_m} 0 10% 0` : `${spacing_l} 0 8% 0`)};
	margin-bottom: ${(props) => (props.isNarrow ? `auto` : `120.5px`)};
	height: 100%;
	z-index: -1;
`;
//#endregion

// #region ViewDetails Style
export const StyledContainerViewDetails = styled.View<any>`
	width: 58%;
	height: ${(props) => (props.isReduceHeight ? "70vh" : "100vh")};
	padding: 0 0 0 122px;
	z-index: -1;
`;

export const StyledButtonLoader = styled.View`
	height: 72px;
	border-radius: 16px;
	overflow: hidden;
	margin-bottom: ${spacing_m};
`;

export const StyledButtonContainer = styled.View<any>`
	width: 81%;
	${(props) =>
		!props.isButtonVisible
			? css`
					display: block;
				`
			: css`
					display: none;
				`}
`;

export const StyledButton = styled.View`
	flex-direction: row;
	align-items: center;
	width: 100%;
`;

export const StyledButtonText = styled.View`
	left: -10px;
`;

export const stylesViewDetails = StyleSheet.create({
	metadata: {
		color: "white",
	},
	button: {
		fontSize: 25,
	},
});

export const BlurFooter = styled.View`
	width: 100%;
	height: 90px;
	position: absolute;
	bottom: 0;
	background-image: linear-gradient(to bottom, transparent, black);
`;

export const StyledMaskGroupNarrow = styled.View<any>`
	position: absolute;
	right: 0;
	bottom: 0;
	width: 50vw;
	height: calc(100vh - 5rem);
	flex-shrink: 0;
	${(props) =>
		!props.bgImage &&
		css`
			background-color: black;
		`}

	${(props) =>
		props.bgImage &&
		css`
			mask-image: linear-gradient(-90deg, #000 0%, rgba(0, 0, 0, 0.95) 12.43%, rgba(0, 0, 0, 0.6) 60.51%, rgba(0, 0, 0, 0) 100%);
			background-image: url(${props.bgImage});
			background-position: top right;
			background-repeat: no-repeat;
			background-size: cover;
		`}
`;
export const StyleDetailsContainerNarrow = styled.View`
	display: flex;
	width: 60vw;
	padding: 1rem 1rem 10rem;
	justify-content: center;
	align-items: flex-start;
	gap: 1rem;
`;

export const StyledTextTemplate = styled.View`
	display: flex;
	width: 100%;
	flex-direction: column;
	align-items: flex-start;
`;

export const StyledFrame = styled.View`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	gap: 1rem;
	align-self: stretch;
`;

export const StyledDetailsFrame = styled.View`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	gap: 1rem;
	align-self: stretch;
	padding-left: 0.5rem;
`;

export const StyledFrameNarrow = styled.View`
	display: flex;
	flex-direction: row;
	width: 31.25rem;
	justify-content: center;
	align-items: flex-start;
`;

export const StyledButtonContainerNarrow = styled.View`
	display: flex;
	width: 31.25rem;
	flex-direction: column;
	align-items: flex-start;
	gap: 1rem;
	flex-shrink: 0;
	z-index: 99999;
`;

export const StyledSynopsisNarrow = styled.Text<any>`
	height: auto;
	width: ${(props) => (props.isDetails ? "100%" : "31.25rem")};
	align-self: stretch;
	overflow: hidden;
	color: #f2f2f2;
	text-overflow: ellipsis;
	font-family: Nunito;
	font-size: 1.3125rem;
	font-style: normal;
	font-weight: 400;
	line-height: 1.5625rem;
`;

export const StyledTextTemplateNarrow = styled.View`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	flex: 1 0 0;
`;

export const StyledTextFrame = styled.View<any>`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	gap: 1rem;
	align-self: stretch;
	padding-left: ${(props) => (props.isDetails ? ".5rem" : "1.5rem")};
`;

export const StyledRatingsNarrow = styled.Text<any>`
	width: 31.25rem;
	align-self: stretch;
	color: #f2f2f2;
	font-family: Nunito;
	font-size: 0.875rem;
	font-style: normal;
	font-weight: 400;
	line-height: 1rem;
`;

export const StyledCopyRightNarrow = styled.Text<any>`
	width: 100%;
	color: #f2f2f2;
	font-family: Nunito;
	font-size: 0.875rem;
	font-style: normal;
	font-weight: 400;
	line-height: 1rem;
	padding-left: 0.5rem;
`;
export const StyledPackshotNarrow = styled.View`
	display: flex;
	width: 10.875rem;
	height: 16.3125rem;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	flex-shrink: 0;
	border-radius: 0.75rem;
	outline-color: rgba(255, 255, 255, 0.3);
	outline-style: solid;
	outline-width: 2px;
`;
//#endregion
